function registerOnload() {


    //categorias: show/hide dados do local
    // $('#categories').change(function () {
    //     var category = $(this).find(':selected').data('title');
    //
    //     if (category == 'Hotel') {
    //         $('.localContent').fadeIn('slow');
    //     } else {
    //         $('.localContent').fadeOut('slow');
    //     }
    // });

    /*
     * SUBMIT FORM
     */

    $("#form_register").submit(function(e) {
        e.preventDefault();

        // VALIDATE
    }).validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 6
            },
            password_confirm: {
                required: true,
                minlength: 6,
                equalTo: "#password"
            },
            category: "required",
            first_name: "required",
            last_name: "required",
            document: "required",
            birth_date: "required",
            cell_phone: "required",
            state: "required",
            city: "required",
            terms_of_use: "required",
        },
        messages: {
            password_confirm: {
                equalTo: "Digite a mesma senha novamente"
            }
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            element.addClass("is-invalid");
            error.insertAfter(element).addClass("form-text").addClass("text-danger");
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass("is-invalid");
        },

        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass("is-invalid");
            $(element > "small").fadeOut();
        },

        submitHandler: function () {
            var form = $("#form_register");
            var flashClass = "ajax_response";
            var flash = $("." + flashClass);
            var modal_size = "sm";
            var modal = "#modal_" + modal_size;
            var modal_title = $(".modal_title_" + modal_size);
            var modal_content = $(".modal_content_" + modal_size);

            grecaptcha.ready(function() {
                grecaptcha.execute('6Ld8hP8UAAAAALeKcOL8mdRqtJGj0WOSZg6A222O', {action: 'submit'}).then(function(token) {

                    form.ajaxSubmit({
                        url: form.attr("action"),
                        type: "POST",
                        data: {token: token},
                        dataType: "json",
                        beforeSend: function () {
                            loader.fadeIn(200);
                        },
                        success: function (response) {

                            //redirect
                            if (response.redirect) {
                                window.location.href = response.redirect;
                            } else {
                                loader.fadeOut(200);
                            }

                            //message flash
                            if (response.message_flash) {
                                if (flash.length) {
                                    flash.html(response.message_flash).fadeIn(100);
                                } else {
                                    form.prepend("<div class='" + flashClass + "'>" + response.message_flash + "</div>")
                                        .find("." + flashClass);
                                }
                            } else {
                                flash.fadeOut(100);
                            }

                            //message
                            if (response.message) {
                                setTimeout(function() {
                                    modal_title.html("Ops!");
                                    modal_content.html(response.message);
                                    openModal(modal);
                                }, 400);
                            }

                        },
                        complete: function () {
                            if (form.data("reset") === true) {
                                form.trigger("reset");
                            }
                        },
                        error: function (xhr, status, error) {
                            var message = "<div class='message error icon-warning'>Desculpe mas não foi possível processar a requisição. Favor tente novamente!</div>";

                            setTimeout(function() {
                                modal_title.html("Ops!");
                                modal_content.html(message);
                                openModal(modal);
                            }, 400);

                            loader.fadeOut();

                            //grava log
                            var errorMessage = xhr.status + ': ' + xhr.responseText + " - " + status + " - " + error;
                            $.post(url("/log/error"), {platform:'ticket', origin:'register', description:errorMessage});
                        }
                    });

                });
            });

            return false;
        }
    });

}

function registerJuridicalOnload() {

    $('#form_local').validate({
        rules: {
            corporate_name: "required",
            fantasy_name: "required",
            document: "required",
            state_registration: "required",
            street: "required",
            number: {
                required: true,
                number: true
            },
            district: "required",
            state: "required",
            city: "required",
            zip_code: "required",
            terms_of_use: "required",
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            element.addClass("is-invalid");
            error.insertAfter(element).addClass("form-text").addClass("text-danger");
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass("is-invalid");
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass("is-invalid");
            $(element > "small").fadeOut();
        }
    });
}

function registerBankOnload() {

    $('#form_bank').validate({
        rules: {
            bank: "required",
            account_type: "required",
            agency: {
                required: true,
                number: true
            },
            agency_digit: {
                required: true,
                number: true
            },
            account: {
                required: true,
                number: true
            },
            account_digit: {
                required: true,
                number: true
            },
            pix_type_key: "required",
            pix_key: "required"
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            element.addClass("is-invalid");
            error.insertAfter(element).addClass("form-text").addClass("text-danger");
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass("is-invalid");
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass("is-invalid");
            $(element > "small").fadeOut();
        }
    });

}